<template>
  <div>
    <div id="w1">
        
        <div  id="container" v-if="page == 0">
          <header>
            <p id="title">Welcome to the</p>
            <br><br>
          </header>
          <main>
            <div id="main">
              <div class="img"></div>
              <p id="heading">PATHFINDING<br />VISUALIZER <br><small><sub>Tutorial</sub></small></p>
            </div>
          </main>
              <br>
          
          <footer id="buttons" >
            <button v-on:click="skip">SKIP</button>
            <button v-on:click="next">NEXT</button>
          </footer>
        </div>

        <div  id="container" v-if="page == 1">
          <header>
            <p id="title">Select an Algorithm</p>
            <br>
          </header>
          <main>
            <div id="main">
              <div class="img2"></div>
            </div>
          </main>
          <br>
          <footer id="buttons" >
            <button v-on:click="skip">SKIP</button>
            <button v-on:click="previous">PREVIOUS</button>
            <button v-on:click="next">NEXT</button>
          </footer>
        </div>

        <div id="container" v-if="page == 2">
          <header>
            <p id="title">Draw Obstacles</p>
          </header>
          <main>
            <p id="description">Single tap enables wall. Now swipe the cursor to draw walls. Again single tap to disable wall.</p>
            <div id="main">
              <div class="img3"></div>
            </div>
            <br>
          </main>
          <footer id="buttons" >
            <button v-on:click="skip">SKIP</button>
            <button v-on:click="previous">PREVIOUS</button>
            <button v-on:click="next">NEXT</button>
          </footer>
        </div>

        <div id="container" v-if="page == 3">
          <p id="title">Move pointers</p>
          <p id="description">Hold the arrows by clicking the mouse and drag the pointer to the desired location.</p>
          <div id="main"> 
            <div class="img4"></div>
          </div>
          <br>
          <footer id="buttons" >
            <button v-on:click="skip">SKIP</button>
            <button v-on:click="previous">PREVIOUS</button>
            <button v-on:click="next">NEXT</button>
          </footer>
        </div>

        <div id="container" v-if="page == 4">
          <header>
            <p id="title">Visualize and Instant Path</p>
          </header>
          <main>
            <p id="description">Press Visualize to see the working of the algorithm. Use Instant Path to get a quick path</p>
            <div id="main"> 
              <div class="img5"></div>
            </div>
            <br>
          </main>
          <footer id="buttons" >
            <button v-on:click="skip">SKIP</button>
            <button v-on:click="previous">PREVIOUS</button>
            <button v-on:click="next">NEXT</button>
          </footer>
        </div>

        <div id="container" v-if="page == 5">
          <header>
            <p id="title">Clear Path</p>
          </header>
          <main>
            <p id="description"> Clear Path clears only the path and visited nodes.</p>
            <div id="main"> 
              <div class="img6"></div>
            </div>
            <br>
          </main>
          <footer id="buttons" >
            <button v-on:click="skip">SKIP</button>
            <button v-on:click="previous">PREVIOUS</button>
            <button v-on:click="next">NEXT</button>
          </footer>
        </div>

        <div id="container" v-if="page == 6">
          <header>
            <p id="title">Clear Canvas</p>
          </header>
          <main>
            <p id="description">Clear Canvas clears everything: walls, path and, visited nodes.</p>
            <div id="main"> 
              <div class="img7"></div>
            </div>
            <br>
          </main>
          <footer id="buttons" >
            <button v-on:click="skip">SKIP</button>
            <button v-on:click="previous">PREVIOUS</button>
            <button v-on:click="next">NEXT</button>
          </footer>
        </div>

        <div id="container" v-if="page == 7">
          <header>
            <p id="title">Enjoy playing around..</p>
          </header>
          <main>
            <div id="main"> 
              <div class="img8"></div>
            </div>
            <br>
          </main>
          <footer id="buttons" >
            <button v-on:click="previous">PREVIOUS</button>
            <button v-on:click="skip">FINISH</button>
          </footer>
        </div>

    </div>

  </div>
</template>

<script>
import {bus} from "../../src/main";
export default {
  data(){
    return {
      page: 0,
      available: 7
    }
  },
  methods: {
    skip(){
      bus.$emit("end", true);
    },
    next(){
      if(this.page < this.available){
        this.page += 1
      }else{
        bus.$emit("end", true);
      }
    },
    previous(){
      if(this.page > 0){
        this.page -= 1
      }
    }
  }
};
</script>

<style scoped>
  #w1{
    position: fixed;
    align-items: center;
    height: 420px;
    width: 660px;
    border: 1px rgb(212, 212, 212) solid; 
    border-radius: 0.2rem;
    /* position: absolute; */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 0px 15px rgb(219, 219, 219);
  }
  #buttons{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  #heading {
  /* text-align: center; */

  /* padding: 8px; */
  font-family: "Source Sans Pro", sans-serif;
  font-weight: lighter;
  font-size: 55px;
  margin: 0px;
  color: rgba(48, 46, 46, 0.979);
  /* background-color: rgb(17, 0, 27); */
  /* background-color: rgba(7, 7, 7, 0.863); */
}
#description{
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  text-align: center;
  margin: 5px;
}
.img{
  background: url("../../public/rocket.svg");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  padding: 10px;
}
.img2{
  background: url("../../public/select-box.gif");
  background-repeat: no-repeat;
  background-size: contain;
  width: 300px;
  height: 202px;
  
}
.img3{
  background: url("../../public/obs.gif");
  background-repeat: no-repeat;
  background-size: contain;
  width: 400px;
  height: 233px;
  
}
.img4{
  background: url("../../public/pointers.gif");
  background-repeat: no-repeat;
  background-size: contain;
  width: 400px;
  height: 233px;
  
}
.img5{
  background: url("../../public/algo.gif");
  background-repeat: no-repeat;
  background-size: contain;
  width: 400px;
  height: 233px;
  
}
.img6{
  background: url("../../public/clear.gif");
  background-repeat: no-repeat;
  background-size: contain;
  width: 400px;
  height: 233px;
  
}
.img7{
  background: url("../../public/path.gif");
  background-repeat: no-repeat;
  background-size: contain;
  width: 400px;
  height: 233px;
  
}
.img8{
  background: url("../../public/affection.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 400px;
  height: 233px;
  
}
#main {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 660px;
}
#title{
  text-align: center;
  font-size: 25px;
  /* font-family: 'Playfair Display', serif; */
  font-family: 'Bellota', cursive;
  font-weight: lighter;
  color:rgba(105, 104, 104, 0.979);
  /* margin: 15px; */
}
button{
  background-color: rgb(248, 248, 248);
  border: rgb(184, 182, 182) 1px solid;
  height: 35px;
  width: 82px;
  border-radius: 0.2rem;
  outline: none;
  color:rgb(90, 90, 90);
}
button:hover{
  cursor: pointer;
  background-color: rgb(243, 248, 239);
  border: #4fc08d 1px solid;
}
#container{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
